import { useQuery } from '@apollo/client';
import Loading from '../../../components/loading/loading';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import PageHeader from '../../../components/pageHeader/pageHeader';
import { IHilda } from '../../../shared/interfaces/ihilda.interface';
import { IUser } from '../../../shared/interfaces/iuser.interface';
import { GET_USERS_BY_HILDA } from './hildaAwaitingClientApproval.service';

import { useStyles } from './hildaAwaitingClientApproval.styles';
import AwaitingClientApprovalComponent from './awaitingClientApprovalComponent/awaitingClientApprovalComponent';
import { IAwaitingClientApprovalFields } from '../../../shared/interfaces/iform';
import { convertDateFormat } from '../../../shared/utils/gridUtils';
import { IAddress } from '../../../shared/interfaces/iaddress.interface';

const HildaAwaitingClientApprovalDetails = () => {
  const { hildaAccountId }: any = useParams();
  const classes = useStyles();
  const { data, loading, error, refetch } = useQuery(GET_USERS_BY_HILDA, {
    variables: {
      hildaId: hildaAccountId,
      whereHilda: { id: hildaAccountId },
    },
  });

  useEffect(() => {
    refetch({ whereHilda: { id: hildaAccountId } });
    // eslint-disable-next-line
  }, [hildaAccountId]);

  if (loading)
    return (
      <div className={classes.loading}>
        <Loading isLoading />
      </div>
    );

  if (error) return null;

  const personalInformationArr: IUser[] = data.usersByHildaId;
  const hilda: IHilda = data.hilda;
  const accountInfo = {
    accountNumber: hilda.id || '',
    joined: hilda.createdAt || '',
  };
  const advisor: IUser = hilda.advisor;
  const advisorName = advisor.firstName + ' ' + advisor.lastName;
  const accountType = hilda.hildaTypeId || '';
  const address: IAddress = data.hilda.address;

  console.info("hildaAwaitingCLientApprovalInfo", data.hilda)

  const hildaAccountInfo: IAwaitingClientApprovalFields = {
    accountType: accountType || '',
    firstName: personalInformationArr[0].firstName || '',
    lastName: personalInformationArr[0].lastName || '',
    ssn: hilda.taxId || '',
    dateOfBirth: convertDateFormat(personalInformationArr[0].dateOfBirth),
    phoneNumber: personalInformationArr[0].phoneNumber || '',
    email: personalInformationArr[0].email || '',
    address: address?.streetAddress1?.toString() || '',
    firstName2: personalInformationArr[1]?.firstName || '',
    lastName2: personalInformationArr[1]?.lastName || '',
    ssn2: hilda.secondaryTaxId || '',
    dateOfBirth2: convertDateFormat(personalInformationArr[1]?.dateOfBirth),
    phoneNumber2: personalInformationArr[1]?.phoneNumber || '',
    email2: personalInformationArr[1]?.email || '',
    address2: address?.streetAddress1?.toString() || '',
    city: address?.city?.toString() || '',
    state: address?.state?.toString() || '',
    zipCode: address?.zipCode?.toString() || '',
    entityName: hilda.name || '',
    taxId: hilda.taxId || '',
    accountTitle: '',
    entityType: hilda.institution?.institutionType.description || '',
    advisor,
    entityEmail: hilda.email || '',
    signDate: hilda.createdAt,
  };

  return (
    <div>
      <PageHeader
        title={hilda.name || ''}
        accountInfo={accountInfo}
        advisorName={advisorName}
      />
      <AwaitingClientApprovalComponent
        hildaAccountInfo={hildaAccountInfo}
        advisorInfo
      />
    </div>
  );
};

export default HildaAwaitingClientApprovalDetails;
